<button
  type="button"
  procure-button
  variant="stroked"
  prefixSymbol="file_export"
  [loading]="loading()"
  [disabled]="disabled()"
  (click)="exportClick.emit()"
>
  {{ label() }}
</button>
